<template>
  <div class="launchescreen">
    <img src="assets/loader_animhead.gif" alt="">
  </div>
</template>

<script>
import {store} from '../store/store';
import {mapState} from "vuex";


export default {
  name: 'LaunchScreen',
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapState([
      "user",
      "masks",
      "logged"
    ])
  },
  mounted() {
    let routes = this.$router
    setTimeout(function () {
      if (localStorage.getItem('user')) {
        routes.push({name: "camera"});
      } else {
        routes.push({name: "LandingPage"});

      }
    }, 2000)

  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');

.launchescreen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.launchescreen img {
  width: 60%;
}

@media screen and (min-width: 780px) {

  .launchescreen img {
    width: 30%;
  }


}

.blue:first-child {
  margin-bottom: 20px;
}

.blue:last-child {
  margin-top: 20px;
}

.blue {
  padding: 10px;
  border-radius: 10px;
  font-family: 'Bebas Neue', cursive;
  font-size: 26px;
  width: 70%;
  text-align: center;
  background: linear-gradient(#00CDF8, #00ABDD);

}


</style>
